module.exports = __webpack_public_path__ + "img/settings.d137b79c.svg";